module.exports = __webpack_public_path__ + "static/media/aws.259e1339.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Languages/img/aws.svg
// module id = 116
// module chunks = 0